import { MESSENGER_CHANNEL } from 'src/constants/conversations';
import { CHANNEL_BLOCK_REASON, SESSION_WINDOW } from '../constants';
import { resolveAreaSender } from '../resolveAreaSender';
import { IChannelStrategy } from '../types';

/**
 * Messenger: free-form replies from the area page (`area.fb`); no templates.
 */
export const messengerStrategy: IChannelStrategy = {
    resolve: ({ conversation, area }) => {
        const sender = resolveAreaSender(area, MESSENGER_CHANNEL);
        const freeFormBlockReason = !conversation
            ? CHANNEL_BLOCK_REASON.NO_CONVERSATION
            : !sender.senderPhone
              ? CHANNEL_BLOCK_REASON.NO_SENDER
              : null;

        return {
            channel: MESSENGER_CHANNEL,
            provider: sender.provider,
            senderPhone: sender.senderPhone,
            sessionWindow: SESSION_WINDOW.UNKNOWN,
            canSendFreeForm: !freeFormBlockReason,
            canSendTemplate: false,
            freeFormBlockReason,
            templateBlockReason: CHANNEL_BLOCK_REASON.UNSUPPORTED_CHANNEL,
        };
    },
};
